<template>
  <div class="row" style="margin-bottom: 10px; margin-top: 10px">
    <div class="col-md-12 text-center">
      <p
        class="h6 text-secondary"
        v-if="
          retornaSite() == 'Bll' && $siteAdmin == false && propSite !== 'Extra'
        "
        style="margin-bottom: 30px"
      >
        Dark Mode? Selecione em
        <a
          data-toggle="modal"
          data-target="#dialogEditMeusDados"
          role="button"
          type="button"
          style="
            background: none !important;
            border: none;
            color: #069;
            text-decoration: underline;
            cursor: pointer;
          "
          >meus dados</a
        >
      </p>

      <div
        class="h6"
        v-if="
          retornaSite() == 'Bll' && $siteAdmin == false && propSite === 'Extra'
        "
        style="margin-bottom: 30px"
      >
        <div class="d-flex justify-content-center">
          <h3 class="font-weight-bold" v-if="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-plus-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              />
              <path
                d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
              />
            </svg>
          </h3>

          <h3
            class="ml-2 mr-2 font-weight-bold text-primary"
            style="margin-top: 2px"
          >
            Extra
          </h3>
        </div>
        <p>
          Futebol americano, tênis, hockey, lutas, jogos de futebol com delay
        </p>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px"
        v-if="
          retornaTipoUsuario() == 'Assinante' && planoDias > -1 && planoDias < 5
        "
      >
        <div class="col-md-12 text-center text-danger">
          <a class="btn btn-sm btn-success mb-2" href="/pay" v-if="false">
            Renovar +30 dias via PIX
          </a>
          <h5 v-if="planoDias == 0">
            <small
              >Hoje é o último dia do seu plano</small
            >
          </h5>
          <h5 v-if="planoDias > 0">
            <small>Seu plano vence em {{ planoDias + 1 }} dias</small>
          </h5>
        </div>
      </div>

      <div
        class="row"
        style="margin-bottom: 20px; margin-top: 40px"
        v-if="retornaTipoUsuario() == 'Assinante' && !planoAtivo"
      >
        <div class="col-md-12 text-center text-danger">
          <a class="btn btn-sm btn-success mb-2" href="/pay" v-if="false">
            Renovar +30 dias via PIX
          </a>
          <h3>Entre em contato para renovar seu plano</h3>
        </div>
      </div>

      <div class="row" style="zoom: 1; margin-bottom: 20px; display: none">
        <div class="col-md-12 text-center">
          <span>
            <button
              id="atualizarItens"
              type="button"
              class="btn btn-outline-primary btn-sm"
              style="zoom: 1; margin-top: 10px"
              @click="carregarItens()"
            >
              Atualizar
            </button>
          </span>
        </div>
      </div>

      <div class="row" style="margin-bottom: 50px">
        <div class="col-md-12 text-center">
          <ListEventosHome2
            ref="listEventosHome2"
            :aovivo="true"
            :propSite="propSite"
            :propFavorito="propFavorito"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import ListEventosHome2 from "../lists/ListEventosHome2";

export default {
  name: "Home2",
  components: { ListEventosHome2 },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    meusDados() {
      this.$refs.editUsuario.carregarItem("");
    },
    sair() {
      localStorage.removeItem("ckd");
      localStorage.removeItem("ckdCch");

      this.$router.go({ name: "login" });
    },
    carregarItens() {
      this.$refs.listEventosHome2.carregarItens();
    },
    isMobile() {
      const isMobile = window.matchMedia("only screen and (max-width: 760px)");
      return isMobile.matches ? true : false;
    },
  },
  data: function () {
    return {
      planoAtivo: true,
      planoDias: 10,
    };
  },
  props: {
    propSite: { type: String, default: "" },
    propFavorito: { type: Boolean, default: false },
  },
  async mounted() {
    const response = await api.get("/usuario/meus-dados");
    this.planoAtivo = response.data.item.planoAtivo;
    this.planoDias = response.data.item.planoDias;

    setInterval(this.carregarItens, 20000);
  },
};
</script>

<style>
.tituloJogos {
  margin-top: 15px;
}

.botoesTopo {
  margin-top: 60px;
  justify-content: flex-end !important;
}

@media (max-width: 767.98px) {
  .botoesTopo {
    margin-top: 0px;
    justify-content: center !important;
  }
}
</style>